import { render, staticRenderFns } from "./InfrastructureTab.vue?vue&type=template&id=4afec414&scoped=true"
import script from "./InfrastructureTab.vue?vue&type=script&lang=js"
export * from "./InfrastructureTab.vue?vue&type=script&lang=js"
import style0 from "./InfrastructureTab.vue?vue&type=style&index=0&id=4afec414&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afec414",
  null
  
)

export default component.exports